module.exports = __webpack_public_path__ + "static/img/bg-notice.c5e499d1.jpg";